import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { actionTypes, useStateValue } from "../../store";
import Button from "@mui/material/Button";
import Header from "../HIValuePlus/BaseComponents/Header";
import HIFotterMain from "../HIValuePlus/BaseComponents/Footer";
import MenuItem from "@mui/material/MenuItem";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  GetHVPGetCategoryList,
  GetHVPGetSubCategoryList,
  GetHVPStateList,
  GetHVPCityList,
  SellProductByCustomer,
  getCustomerProfile,
  SellProductByCustomerSendOTP,
  SellProductByCustomerOTPVerify,
  GetHVPGetModelList,
  getPriceCalculationCriteria,
  GetPriceCalculation,
  GetHVPGetALLModelList,
  googleCaptchaAPIKey,
} from "../../networkCalls";
import CloseIcon from "@mui/icons-material/Close";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Box,
  Card,
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Rating,
  Typography,
  Stack,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Modal } from "react-bootstrap";
import { set } from "date-fns";
import { format } from "date-fns";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ReplayIcon from "@mui/icons-material/Replay";
import { se } from "date-fns/locale";
import ReCAPTCHA from "react-google-recaptcha";
const UploadBox = ({
  label,
  subLabel,
  onFileSelect,
  file,
  onRemove,
  demoImage,
}) => {
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (file && file.type.startsWith("image/")) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);

      // cleanup URL when component unmounts or file changes
      return () => URL.revokeObjectURL(url);
    } else {
      setPreviewUrl(null);
    }
  }, [file]);
  const [modalshow, setModalShow] = useState(false);

  return (
    <Box>
      <Typography variant="body1" fontWeight="bold" mb={1}>
        {label}
      </Typography>

      <Box
        className="border rounded text-center d-flex flex-column justify-content-center align-items-center position-relative"
        sx={{
          cursor: "pointer",
          minHeight: "180px",
          p: 2,
          borderColor: "#ccc",
          position: "relative",
        }}
      >
        {!previewUrl && demoImage ? (
          <div
            className="position-absolute"
            style={{ bottom: "10px", right: "10px", zIndex: "999" }}
          >
            <p
              className="pointer linkblue mb-0 text-decoration-underline"
              onClick={() => {
                setModalShow(true);
              }}
            >
              Sample Image
            </p>
          </div>
        ) : null}
        {/* If image selected, show preview */}
        {previewUrl ? (
          <>
            <img
              src={previewUrl}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "120px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />

            {/* Action buttons */}
            <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
              {/* Change button */}
              <Button component="label" variant="outlined" size="small">
                Change
                <input
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      const file = e.target.files[0];
                      if (file && file.size > 2 * 1024) {
                        console.log("size", file.size);
                        alert("Max 2MB allowed!");
                        e.target.value = null;
                      } else {
                        onFileSelect(file);
                      }
                      //   onFileSelect(e.target.files[0]);
                    }
                  }}
                />
              </Button>

              {/* Remove button */}
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => onRemove?.()}
              >
                Remove
              </Button>
            </Stack>
          </>
        ) : (
          <>
            <CloudUploadIcon fontSize="large" color="action" />
            <Typography variant="body2" className="mt-2">
              {subLabel}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Drag and drop or click to upload (images only)
            </Typography>

            {/* Hidden Input for selecting file */}
            <Button
              component="label"
              variant="text"
              className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
            >
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => {
                  if (e.target.files.length > 0) {
                    const file = e.target.files[0];
                    if (file && file.size > 2 * 1024 * 1024) {
                      console.log("size", file.size);
                      alert("Max 2MB allowed!");
                      e.target.value = null;
                    } else {
                      onFileSelect(file);
                    }
                    //   onFileSelect(e.target.files[0]);
                  }
                }}
              />
            </Button>
          </>
        )}
      </Box>
      <Modal
        size="md"
        centered
        show={modalshow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded"
        onHide={() => setModalShow(false)}
        aria-labelledby="video-lg"
      >
        <Modal.Header closeButton className=" border-0  mx-4 mt-2  px-0">
          {/* <span className="hivalueplusmodalheader">Price Calculation</span> */}
        </Modal.Header>
        <Modal.Body className="p-0 text-center">
          <div className="px-4 pt-3 pb-3 ">
            <p className="f16 fw-semibold txtlgeay">
              Here is how your sample image should look like.
            </p>
            <img src={demoImage} width={"350px"} />
          </div>
        </Modal.Body>
      </Modal>
    </Box>
  );
};

const validationSchema = yup.object({
  productname: yup.string().required("Product Name is required"),
  yearofmanufacture: yup.string().required("Purchase Year is required"),
  warranty: yup.string().optional(),
  underwarranty: yup.string().required("Please select Yes or No"),

  warranty: yup.string().when("underwarranty", {
    is: "Yes",
    then: (schema) => schema.required("Warranty is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  category: yup.string().required("Product Category is required"),
  subcategory: yup.string().required("Product Sub Category is required"),
  zipcode: yup
    .string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .length(6, "Pincode must be 6 digits")
    .required("Pincode is required"),
  location: yup.string().required("Address is required"),
  frontImage: yup.mixed().required("Cover view image is required"),
  leftImage: yup.mixed().optional().nullable(),
  rightImage: yup.mixed().optional().nullable(),
  topImage: yup.mixed().optional().nullable(),
});
const validationSchemaa = yup.object({
  productname: yup.string().required("Product Name is required"),
  yearofmanufacture: yup.string().required("Purchase Year is required"),
  warranty: yup.string().required("Warranty Date is required"),
  underwarranty: yup.string().optional(),
  workingcondition: yup
    .string()
    .required("Product Working Condition is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  category: yup.string().required("Product Category is required"),
  subcategory: yup.string().required("Product Sub Category is required"),
  zipcode: yup
    .string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .length(6, "Pincode must be 6 digits")
    .required("Pincode is required"),
  location: yup.string().required("Address is required"),
  frontImage: yup.mixed().required("Front view image is required"),
  leftImage: yup.mixed().optional().nullable(),
  rightImage: yup.mixed().optional().nullable(),
  topImage: yup.mixed().optional().nullable(),
});
const validationSchema1 = yup.object({
  name: yup.string().required("Name is required"),
  phone: yup.string().required("Phone Number is required"),
  email: yup.string().optional().email("Enter a valid email"),
});
const validationSchema2 = yup.object({
  otp: yup
    .string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .length(6, "OTP must be 6 digits")
    .required("OTP is required"),
});
const AddProductHIVALUEPLUS = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const TEST_SITE_KEY = googleCaptchaAPIKey;
  const recaptchaRef = React.createRef();
  const [captchavalue, setCaptchavalue] = React.useState("");
  const onVerifyCaptcha = (captchavalue) => {
    setCaptchavalue({ captchavalue });
  };
  // end capcha code

  const [agree, setAgree] = useState(false);
  const haveAgree = (event) => {
    setAgree(event.target.checked);
  };
  const [{ token, huid }, dispatch] = useStateValue();
  const [customerData, setCustomerData] = React.useState(null);

  const [errMessage, setErrMessage] = useState("");
  const [dealererrMessage, setDealerErrMessage] = useState("");
  const [susMessage, setSusMessage] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [sellingId, setSellingId] = useState(null);
  const [show, setShow] = useState(false);
  const [Verificationshow, setVerificationShow] = useState(false);
  const [otpverificationresponse, setOTPverificationRespoanse] = useState("");
  const [dealershow, setdealerShow] = useState(false);
  const [calculatedPrice, setCalculatedPrice] = useState("");
  const [dealerList, setDealerList] = useState([]);
  const handleClose = () => {
    setShow(false);
    setChangetoOTP(false);
  };
  const handleShow = () => setShow(true);

  const pullCategoryList = () => {
    GetHVPGetCategoryList().then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.categoryList.map((item) => ({
            id: item.id,
            label: item.name,
            image: item.image,
            cover: item.cover,
            front: item.front,
            top: item.top,
            side: item.side,
          }));
          setCategoryList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  const [criteriaList, setCriteriaList] = useState([]);
  const pullCriteriaList = (value) => {
    var data = new FormData();
    data.append("category", value);
    getPriceCalculationCriteria(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setCriteriaList(res?.data?.PriceCalculationCriteria);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  const [subCategoryList, setSubcategoryList] = useState([]);
  const pullSubCategoryList = (value) => {
    var data = new FormData();
    data.append("categoryId", value);
    GetHVPGetSubCategoryList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.subCategoryList.map((item) => ({
            id: item.id,
            label: item.name,
            image: item.image,
          }));
          setSubcategoryList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  const callApiProfile = () => {
    var data = new FormData();
    data.append("customerId", huid);
    data.append("XAuth", token);
    // setLoading(true);
    getCustomerProfile(data).then((res) => {
      console.log("getCustomerProfile", res);
      // setLoading(false);
      switch (res.data.status) {
        case 1:
          setCustomerData(res.data.customerData);
          return true;
        case 0:
          setErrMessage(res.data.msz);
          break;
        case 2:
          dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
          break;
        default:
          return;
      }
    });
  };
  const [stateList, setStateList] = useState([]);
  const pullStateList = () => {
    GetHVPStateList().then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.stateList.map((item) => ({
            id: item.key,
            label: item.name,
          }));
          setStateList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  const [cityList, setCityList] = useState([]);
  const pullCityList = (value) => {
    var data = new FormData();
    data.append("state", value);
    GetHVPCityList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.cityList.map((item) => ({
            id: item.key,
            label: item.name,
          }));
          setCityList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  const [modelList, setModelList] = useState([]);
  const pullModelList = (value, newvalue) => {
    var data = new FormData();
    data.append("categoryId", value);
    data.append("subCategoryId", "");
    GetHVPGetModelList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.modelListArray.map((item) => ({
            id: item.key,
            label: item.name,
            categoryId: item.categoryId,
            category: item.category,
            subCategoryId: item.subCategoryId,
            subCategory: item.subCategory,
          }));
          setModelList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  useEffect(() => {
    pullCategoryList();
    pullStateList();
    callApiProfile();
  }, [token, huid]);

  const formik = useFormik({
    initialValues: {
      productname: "",
      yearofmanufacture: "",
      category: "",
      subcategory: "",
      categoryname: "",
      subcategoryname: "",
      warranty: "",
      underwarranty: "",
      workingcondition: "",
      city: "",
      state: "",
      zipcode: "",
      location: "",
      frontImage: null,
      leftImage: null,
      rightImage: null,
      topImage: null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("values", values);
      var data = new FormData();
      data.append("customerId", huid);
      data.append("XAuth", token);
      data.append("productName", values.productname);
      data.append("yearOfManufacture", values.yearofmanufacture);
      data.append("category", values.category);
      data.append("subCategory", values.subcategory);
      data.append("warranty", values.warranty);
      data.append("condition", values.workingcondition);
      data.append("state", values.state);
      data.append("city", values.city);
      data.append("pincode", values.zipcode);
      data.append("location", values.location);
      data.append("image_1", values.frontImage);
      data.append("image_2", values.leftImage === null ? "" : values.leftImage);
      data.append(
        "image_3",
        values.rightImage === null ? "" : values.rightImage
      );
      data.append("image_4", values.topImage === null ? "" : values.topImage);
      SellProductByCustomer(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            console.log("response ", res);
            setDealerList(res.data.dealerList);
            setdealerShow(true);
            setSellingId(res.data.sellingId);
            // handleShow();

            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //  dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
    },
  });

  useEffect(() => {
    setCityList([]);
    formik.setFieldValue("city", "");
  }, [formik.values.state]);
  const [democoverimage, setDemoCoverImage] = useState(null);
  const [demoTopimage, setDemoTopImage] = useState(null);
  const [demoFrontimage, setDemoFrontImage] = useState(null);
  const [demoSideimage, setDemoSideImage] = useState(null);

  /// OTP MODAL "/////" //////
  const [changetoOTP, setChangetoOTP] = useState(false);

  const formikOtp = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: `${customerData?.firstName} ${customerData?.lastName}`,
      phone: `${customerData?.phone}`,
      email: `${customerData?.email}`,
    },
    validationSchema: validationSchema1,
    onSubmit: (values) => {
      console.log("values", values);
      const dealer = selected.map((val) => {
        return { dealerId: val.dealerid };
      });
      var data = new FormData();
      data.append("customerId", huid);
      data.append("XAuth", token);
      data.append("name", values.name);
      data.append("phone", values.phone);
      data.append("email", values.email);
      data.append("dealerList", JSON.stringify(dealer));
      data.append("sellingId", sellingId);
      SellProductByCustomerSendOTP(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            setSellingId(res.data.sellingId);
            setChangetoOTP(true);

            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //  dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
    },
  });
  const formikOtpVerify = useFormik({
    enableReinitialize: true,
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchema2,
    onSubmit: (values) => {
      console.log("values", values);
      var data = new FormData();
      data.append("customerId", huid);
      data.append("XAuth", token);
      data.append("otp", values.otp);
      data.append("sellingId", sellingId);
      SellProductByCustomerOTPVerify(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            setSellingId(res.data.sellingId);
            setShow(false);
            setChangetoOTP(false);
            setVerificationShow(true);
            console.log("response ", res.data.msz);
            setOTPverificationRespoanse(res.data.msz);
            // navigate("/myaccount/sell-your-product");

            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          case 2:
            //  dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
            break;
          default:
            return;
        }
      });
      // setChangetoOTP(true);
    },
  });
  /// OTP MODAL "/////" //////

  const [modalshow, setModalShow] = useState(false);
  const [warrantyvalue, setwarrantyValue] = React.useState(null);

  const [startwarrantydate, setStartwarrantyDate] = React.useState(null);
  const handlewarantyChange = (newValue) => {
    console.log("newValue", newValue, format(newValue, "dd-MM-yyyy"));
    setwarrantyValue(newValue);

    setStartwarrantyDate(format(newValue, "dd-MM-yyyy"));
    formik.setFieldValue("warranty", format(newValue, "dd-MM-yyyy") || "");
  };
  // const [invoiceAmount, setInvoiceAmount] = useState("");
  const [value, setValue] = React.useState(null);

  const [startdate, setStartDate] = React.useState(null);
  const handleChange = (newValue) => {
    console.log("newValue", newValue, format(newValue, "yyyy-MM-dd"));
    setValue(newValue);

    setStartDate(format(newValue, "yyyy-MM-dd"));
  };
  const [invoiceAmount, setInvoiceAmount] = useState("");

  // ⭐ Update rating when user clicks
  const handleRatingChange = (sectionIndex, rowIndex, newValue) => {
    setCriteriaList((prev) =>
      prev.map((section, sIdx) =>
        sIdx === sectionIndex
          ? {
            ...section,
            List: section.List.map((row, rIdx) =>
              rIdx === rowIndex ? { ...row, star: newValue } : row
            ),
          }
          : section
      )
    );
  };
  const handleSubmitCalculation = (e) => {
    e.preventDefault();
    var data = new FormData();
    data.append("customerId", huid);
    data.append("XAuth", token);
    data.append("category", formik.values.category);
    data.append("invoiceDate", startdate);
    data.append("invoicePrice", invoiceAmount);
    data.append("criteria", JSON.stringify(criteriaList));
    GetPriceCalculation(data)
      .then((res) => {
        console.log("res", res);
        res.data.status === 1 ? setModalShow(false) : setModalShow(true);
        res.data.status === 1
          ? setCalculatedPrice(res.data.Price)
          : setCalculatedPrice("");
      })
      .catch((err) => { });
    console.log("data", data, JSON.stringify(criteriaList));
  };
  const commonTextFieldStyles = {
    "& .MuiOutlinedInput-root": {
      height: 40, // Set your desired fixed height
      "& fieldset": {
        borderRadius: "6px", // Consistent border radius
      },
    },
  };
  const [selected, setSelected] = useState([]);

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((d) => d.id !== id.id) : [...prev, id]
    );
  };
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2000 + 1 }, (_, i) => ({
    id: i + 1,
    label: 2000 + i,
  }));
  console.log("selected dealers", formik.values);
  const enabledbtncapt = captchavalue != "" && agree;
  const [showConsent, setShowConsent] = useState(false);

  return (
    <>
      <Header />

      <div className="innerpagebg pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-9 text-left m-auto">
              <div className="d-flex align-items-center">
                <h4 className="d-inline-block m-0 fw-bold text-uppercase">
                  <span className="texthivalueplus">My </span>{" "}
                  <span className="txtdgray">Products</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="container mt-3">
          <div className="row">
            <div className="col-lg-9 col-md-12 col-12 m-auto">
              {errMessage ? <Alert severity="error">{errMessage}</Alert> : null}
              {susMessage ? (
                <Alert severity="success">{susMessage}</Alert>
              ) : null}
              <div className="card p-4 mb-3  position-relative">
                <form
                  onSubmit={formik.handleSubmit}
                  autoComplete="off"
                  className=""
                >
                  <div className="row">
                    {/* Product Name */}
                    {/* <div className="col-lg-6 col-12">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="productname"
                        name="productname"
                        label="Enter Product Name *"
                        type="text"
                        value={formik.values.productname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.productname &&
                          Boolean(formik.errors.productname)
                        }
                        helperText={
                          formik.touched.productname &&
                          formik.errors.productname
                        }
                      />
                    </div> */}

                    {/* Category */}
                    <div className="col-lg-6 col-md-6 col-12">
                      {/* <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="category"
                        name="category"
                        label="category"
                        type="text"
                        readOnly={true}
                        value={formik.values.categoryname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.category &&
                          Boolean(formik.errors.category)
                        }
                        helperText={
                          formik.touched.category && formik.errors.category
                        }
                      /> */}
                      <Autocomplete
                        disablePortal
                        id="category"
                        options={categoryList}
                        value={
                          categoryList.find(
                            (opt) => opt.id === formik.values.category
                          ) || null
                        }
                        onChange={(e, value) => {
                          formik.setFieldValue("category", value?.id || "");
                          setDemoCoverImage(value?.cover);
                          setDemoFrontImage(value?.front);
                          setDemoTopImage(value?.top);
                          setDemoSideImage(value?.side);
                          pullModelList(value?.id);
                          pullCriteriaList(value?.id);
                        }}
                        onBlur={() => formik.setFieldTouched("category", true)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Category"
                            className="mb-4 w-100"
                            error={
                              formik.touched.category &&
                              Boolean(formik.errors.category)
                            }
                            helperText={
                              formik.touched.category && formik.errors.category
                            }
                          />
                        )}
                      />
                    </div>
                    {/* { Modal Name} */}
                    <div className="col-lg-6 col-md-6 col-12">
                      <Autocomplete
                        disablePortal
                        id="productname"
                        options={modelList}
                        value={
                          modelList.find(
                            (opt) => opt.label === formik.values.productname
                          ) || null
                        }
                        onChange={(e, value) => {
                          formik.setFieldValue(
                            "productname",
                            value?.label || ""
                          );
                          // formik.setFieldValue(
                          //   "categoryname",
                          //   value?.category || ""
                          // );
                          formik.setFieldValue(
                            "subcategoryname",
                            value?.subCategory || ""
                          );
                          // formik.setFieldValue(
                          //   "category",
                          //   value?.categoryId || ""
                          // );
                          formik.setFieldValue(
                            "subcategory",
                            value?.subCategoryId || ""
                          );
                          pullCriteriaList(value?.categoryId);
                          // pullModelList(formik.values.category,value?.id);
                        }}
                        onBlur={() =>
                          formik.setFieldTouched("productname", true)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Model Name"
                            className="mb-4 w-100"
                            error={
                              formik.touched.productname &&
                              Boolean(formik.errors.productname)
                            }
                            helperText={
                              formik.touched.productname &&
                              formik.errors.productname
                            }
                          />
                        )}
                      />
                    </div>
                    {/* Sub Category */}
                    <div className="col-lg-6 col-md-6 col-12">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="subcategory"
                        name="subcategory"
                        label="Sub Category"
                        readOnly={true}
                        type="text"
                        value={formik.values.subcategoryname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.subcategory &&
                          Boolean(formik.errors.subcategory)
                        }
                        helperText={
                          formik.touched.subcategory &&
                          formik.errors.subcategory
                        }
                      />
                      {/* <Autocomplete
                        disablePortal
                        id="subcategory"
                        options={subCategoryList}
                        value={
                          subCategoryList.find(
                            (opt) => opt.id === formik.values.subcategory
                          ) || null
                        }
                        onChange={(e, value) => {
                          formik.setFieldValue("subcategory", value?.id || "");
                          pullModelList(formik.values.category, value?.id);
                        }}
                        onBlur={() =>
                          formik.setFieldTouched("subcategory", true)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            label="Select Sub Category"
                            className="mb-4 w-100"
                            error={
                              formik.touched.subcategory &&
                              Boolean(formik.errors.subcategory)
                            }
                            helperText={
                              formik.touched.subcategory &&
                              formik.errors.subcategory
                            }
                          />
                        )}
                      /> */}
                    </div>
                    {/* Year of Manufacture */}
                    <div className="col-lg-6 col-12">
                      <Autocomplete
                        disablePortal
                        id="yearofmanufacture"
                        options={years}
                        value={
                          years.find(
                            (opt) =>
                              opt.label === formik.values.yearofmanufacture
                          ) || null
                        }
                        onChange={(e, value) => {
                          console.log("selected year", value);
                          formik.setFieldValue(
                            "yearofmanufacture",
                            value?.label || ""
                          );
                          pullCityList(value?.label);
                          //   setCityList([]);
                        }}
                        onBlur={() =>
                          formik.setFieldTouched("yearofmanufacture", true)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            className="mb-4 w-100"
                            label="Year of Purchase"
                            error={
                              formik.touched.yearofmanufacture &&
                              Boolean(formik.errors.yearofmanufacture)
                            }
                            helperText={
                              formik.touched.yearofmanufacture &&
                              formik.errors.yearofmanufacture
                            }
                          />
                        )}
                      />
                      {/* <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="yearofmanufacture"
                        name="yearofmanufacture"
                        label="Year of Purchase"
                        type="text"
                        value={formik.values.yearofmanufacture}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.yearofmanufacture &&
                          Boolean(formik.errors.yearofmanufacture)
                        }
                        helperText={
                          formik.touched.yearofmanufacture &&
                          formik.errors.yearofmanufacture
                        }
                      /> */}
                    </div>

                    {/* Warranty */}
                    <div className="col-lg-6 col-12">
                      <div className="row">
                        <div className="col-6">
                          <Autocomplete
                            disablePortal
                            id="underwarranty"
                            options={[
                              { label: "Yes", id: 1 },
                              { label: "No", id: 2 },
                            ]}
                            value={
                              [
                                { label: "Yes", id: 1 },
                                { label: "No", id: 2 },
                              ].find(
                                (opt) =>
                                  opt.label === formik.values.underwarranty
                              ) || null
                            }
                            onChange={(e, value) => {
                              formik.setFieldValue(
                                "underwarranty",
                                value?.label || ""
                              );
                              // pullCityList(value?.label);
                              //   setCityList([]);
                            }}
                            onBlur={() =>
                              formik.setFieldTouched("underwarranty", true)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                className="mb-4 w-100 "
                                label="Under Warranty"
                                error={
                                  formik.touched.underwarranty &&
                                  Boolean(formik.errors.underwarranty)
                                }
                                helperText={
                                  formik.touched.underwarranty &&
                                  formik.errors.underwarranty
                                }
                              />
                            )}
                          />
                        </div>
                        <div className="col-6">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                              label="Warranty Expiry Date"
                              views={["year", "month", "day"]}
                              inputFormat="dd-MM-yyyy"
                              value={warrantyvalue}
                              readOnly={
                                formik.values.underwarranty === "Yes"
                                  ? false
                                  : true
                              }
                              format="dd-MM-yyyy"
                              // minDate={new Date("2014-01-01")}
                              // maxDate={new Date()}
                              onChange={handlewarantyChange}
                              slotProps={{
                                textField: {
                                  variant: "standard", // ✅ forces bottom border only
                                  fullWidth: true,
                                  error:
                                    formik.touched.warranty &&
                                    Boolean(formik.errors.warranty),
                                  helperText:
                                    formik.touched.warranty &&
                                    formik.errors.warranty,
                                },
                              }}
                            />
                          </LocalizationProvider>

                          {/* <TextField
                            className="mb-4 w-100 "
                            variant="standard"
                            slotProps={{
                              input: {
                                readOnly:
                                  formik.values.underwarranty === "Yes"
                                    ? false
                                    : true,
                              },
                            }}
                            id="warranty"
                            name="warranty"
                            label="Warranty in Months"
                            type="text"
                            value={formik.values.warranty}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.warranty &&
                              Boolean(formik.errors.warranty)
                            }
                            helperText={
                              formik.touched.warranty && formik.errors.warranty
                            }
                          /> */}
                        </div>
                      </div>
                    </div>

                    {/* Working Condition */}
                    <div className="col-lg-6 col-12">
                      <Autocomplete
                        disablePortal
                        id="workingcondition"
                        options={[
                          { label: "Yes", id: 1 },
                          { label: "No", id: 2 },
                        ]}
                        value={
                          [
                            { label: "Yes", id: 1 },
                            { label: "No", id: 2 },
                          ].find(
                            (opt) =>
                              opt.label === formik.values.workingcondition
                          ) || null
                        }
                        onChange={(e, value) => {
                          formik.setFieldValue(
                            "workingcondition",
                            value?.label || ""
                          );
                          // pullCityList(value?.label);
                          //   setCityList([]);
                        }}
                        onBlur={() =>
                          formik.setFieldTouched("workingcondition", true)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            className="mb-4 w-100"
                            label="Working Condition"
                            error={
                              formik.touched.workingcondition &&
                              Boolean(formik.errors.workingcondition)
                            }
                            helperText={
                              formik.touched.workingcondition &&
                              formik.errors.workingcondition
                            }
                          />
                        )}
                      />
                    </div>

                    {/* State */}
                    <div className="col-lg-6 col-md-6 col-12">
                      <Autocomplete
                        disablePortal
                        id="state"
                        options={stateList}
                        value={
                          stateList.find(
                            (opt) => opt.label === formik.values.state
                          ) || null
                        }
                        onChange={(e, value) => {
                          formik.setFieldValue("state", value?.label || "");
                          pullCityList(value?.label);
                          //   setCityList([]);
                        }}
                        onBlur={() => formik.setFieldTouched("state", true)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            className="mb-4 w-100"
                            label="Select State"
                            error={
                              formik.touched.state &&
                              Boolean(formik.errors.state)
                            }
                            helperText={
                              formik.touched.state && formik.errors.state
                            }
                          />
                        )}
                      />
                    </div>

                    {/* City */}
                    <div className="col-lg-6 col-md-6 col-12">
                      <Autocomplete
                        disablePortal
                        id="city"
                        options={cityList}
                        value={
                          cityList.find(
                            (opt) => opt.label === formik.values.city
                          ) || null
                        }
                        onChange={(e, value) => {
                          formik.setFieldValue("city", value?.label || "");
                        }}
                        onBlur={() => formik.setFieldTouched("city", true)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            className="mb-4 w-100"
                            label="Select City"
                            error={
                              formik.touched.city && Boolean(formik.errors.city)
                            }
                            helperText={
                              formik.touched.city && formik.errors.city
                            }
                          />
                        )}
                      />
                    </div>

                    {/* Location */}
                    <div className="col-lg-6 col-12">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="location"
                        name="location"
                        label="Location *"
                        type="text"
                        value={formik.values.location}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.location &&
                          Boolean(formik.errors.location)
                        }
                        helperText={
                          formik.touched.location && formik.errors.location
                        }
                      />
                    </div>

                    {/* Zipcode */}
                    <div className="col-lg-6 col-md-6 col-12">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="zipcode"
                        name="zipcode"
                        inputProps={{ maxLength: 6 }}
                        label="Pincode *"
                        type="text"
                        value={formik.values.zipcode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.zipcode &&
                          Boolean(formik.errors.zipcode)
                        }
                        helperText={
                          formik.touched.zipcode && formik.errors.zipcode
                        }
                      />
                    </div>

                    {/* Uploads */}
                    <div className="col-lg-6 col-12 mb-3">
                      <UploadBox
                        label="Upload Cover Image*"
                        subLabel="Upload Cover image of the product"
                        demoImage={democoverimage}
                        file={formik.values.frontImage}
                        onFileSelect={(file) =>
                          formik.setFieldValue("frontImage", file)
                        }
                        onRemove={() =>
                          formik.setFieldValue("frontImage", null)
                        }
                      />
                      {formik.touched.frontImage &&
                        formik.errors.frontImage && (
                          <Typography
                            color="error"
                            variant="caption"
                            className="ms-3"
                          >
                            {formik.errors.frontImage}
                          </Typography>
                        )}
                    </div>
                    <div className="col-lg-6 col-12 mb-3">
                      <UploadBox
                        label="Upload Front View*"
                        demoImage={demoFrontimage}
                        subLabel="Upload Front view of the product"
                        file={formik.values.leftImage}
                        onFileSelect={(file) =>
                          formik.setFieldValue("leftImage", file)
                        }
                        onRemove={() => formik.setFieldValue("leftImage", null)}
                      />
                      {formik.touched.leftImage && formik.errors.leftImage && (
                        <Typography
                          color="error"
                          variant="caption"
                          className="ms-3"
                        >
                          {formik.errors.leftImage}
                        </Typography>
                      )}
                    </div>
                    <div className="col-lg-6 col-12 mb-3">
                      <UploadBox
                        label="Upload Top View*"
                        demoImage={demoTopimage}
                        subLabel="Upload top view of the product"
                        file={formik.values.rightImage}
                        onFileSelect={(file) =>
                          formik.setFieldValue("rightImage", file)
                        }
                        onRemove={() =>
                          formik.setFieldValue("rightImage", null)
                        }
                      />
                      {formik.touched.rightImage &&
                        formik.errors.rightImage && (
                          <Typography
                            color="error"
                            variant="caption"
                            className="ms-3"
                          >
                            {formik.errors.rightImage}
                          </Typography>
                        )}
                    </div>
                    <div className="col-lg-6 col-12 mb-3">
                      <UploadBox
                        label="Upload Side View*"
                        demoImage={demoSideimage}
                        subLabel="Upload side view of the product"
                        file={formik.values.topImage}
                        onFileSelect={(file) =>
                          formik.setFieldValue("topImage", file)
                        }
                        onRemove={() => formik.setFieldValue("topImage", null)}
                      />
                      {formik.touched.topImage && formik.errors.topImage && (
                        <Typography
                          color="error"
                          variant="caption"
                          className="ms-3"
                        >
                          {formik.errors.topImage}
                        </Typography>
                      )}
                    </div>
                    {/* Submit */}
                    <div className="col-lg-12 col-12">
                      <div className="relative w-full d-flex justify-content-end mb-3">
                        {/* {calculatedPrice === "" ? (
                      <button
                        variant="contained"
                        className=" hivaluepluscancelBtn"
                        // type="submit"
                        onClick={() => {
                          setModalShow(true);
                        }}
                      >
                        Calculate Price
                      </button>
                    ) : (
                      <div className="d-flex gap-3">
                        <div className="f16">
                          <CurrencyRupeeIcon fontSize="small" />{" "}
                          {calculatedPrice}{" "}
                        </div>
                        <ReplayIcon
                          className="pointer"
                          fontSize="small"
                          onClick={() => {
                            setModalShow(true);
                          }}
                        />
                      </div>
                    )} */}
                        <div className="d-flex gap-2">
                          <button
                            variant="contained"
                            className=" hivaluepluscancelBtn"
                          // type="submit"
                          // onClick={() => {
                          //   setShow(true);
                          // }}
                          >
                            Cancel
                          </button>

                          <button
                            variant="contained"
                            className=" hivalueplusSubmitBtn"
                            type="submit"
                          // onClick={() => {
                          //  formik.handleSubmit()
                          // }}
                          >
                            Submit & Verify
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                {/* <div
                  className=" position-absolute bottom-4 start-4"
                  style={{ bottom: calculatedPrice === "" ? "25px" : "40px" }}
                >
                  <div className="relative w-full d-flex justify-content-between mb-3">
                    {calculatedPrice === "" ? (
                      <button
                        variant="contained"
                        className=" hivaluepluscancelBtn"
                        // type="submit"
                        onClick={() => {
                          setModalShow(true);
                        }}
                      >
                        Calculate Price
                      </button>
                    ) : (
                      <div className="d-flex gap-3">
                        <div className="f16">
                          <CurrencyRupeeIcon fontSize="small" />{" "}
                          {calculatedPrice}{" "}
                        </div>
                        <ReplayIcon
                          className="pointer"
                          fontSize="small"
                          onClick={() => {
                            setModalShow(true);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        show={show}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => handleClose()}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => handleClose()}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className="px-5 m-5">
            <div className="row">
              <div className="col-12">
                <h4 className=" m-0 fw-bold text-uppercase text-center">
                  <span className="txtdgray">OTP Verification</span>
                </h4>
              </div>
              {changetoOTP ? (
                <form
                  className="col-12"
                  onSubmit={formikOtpVerify.handleSubmit}
                  autoComplete="off"
                >
                  <div>
                    <div className="mt-3">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="otp"
                        name="otp"
                        label="Enter 6 digit code *"
                        type="text"
                        value={formikOtpVerify.values.otp}
                        onChange={formikOtpVerify.handleChange}
                        onBlur={formikOtpVerify.handleBlur}
                        error={
                          formikOtpVerify.touched.otp &&
                          Boolean(formikOtp.errors.otp)
                        }
                        helperText={
                          formikOtpVerify.touched.otp &&
                          formikOtpVerify.errors.otp
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-12">
                    <div className="relative w-full mb-3">
                      <Button
                        variant="contained"
                        className="w-100 hivalueplusSubmitBtn"
                        type="submit"
                      // onClick={() => {
                      //   setShow(true);
                      // }}
                      >
                        Verify
                      </Button>
                    </div>
                  </div>
                </form>
              ) : (
                <form
                  className="col-12"
                  onSubmit={formikOtp.handleSubmit}
                  autoComplete="off"
                >
                  <div>
                    <div className="mt-3">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="name"
                        name="name"
                        label="Your Name *"
                        type="text"
                        value={formikOtp.values.name}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.name &&
                          Boolean(formikOtp.errors.name)
                        }
                        helperText={
                          formikOtp.touched.name && formikOtp.errors.name
                        }
                      />
                    </div>
                    <div className="">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="phone"
                        name="phone"
                        label="Phone Number *"
                        type="text"
                        value={formikOtp.values.phone}
                        onChange={formikOtp.handleChange}
                        disabled
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.phone &&
                          Boolean(formikOtp.errors.phone)
                        }
                        helperText={
                          formikOtp.touched.phone && formikOtp.errors.phone
                        }
                      />
                    </div>
                    <div className="">
                      <TextField
                        className="mb-4 w-100"
                        variant="standard"
                        id="email"
                        name="email"
                        label="Email"
                        type="text"
                        value={formikOtp.values.email}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.email &&
                          Boolean(formikOtp.errors.email)
                        }
                        helperText={
                          formikOtp.touched.email && formikOtp.errors.email
                        }
                      />
                    </div>
                    <div className="f12 mb-2">
                      <div className="d-flex align-items-center">
                        <div>
                          {" "}
                          <FormGroup>
                            <FormControlLabel
                              className="f14"
                              control={
                                <Checkbox
                                  className="f14"
                                  checked={agree}
                                  onChange={haveAgree}
                                />
                              }
                              label=""
                            />
                          </FormGroup>
                        </div>
                       <div className="f12">
                          I hereby consent to <span className="fw-bold">Honda India Power Products Ltd.</span> and its <span className="fw-bold">authorised dealers</span> collecting, processing, and using my personal data
                          {
                            showConsent && <>
                              <br />
                              <span>
                                (such as name, mobile number, email ID, and enquiry details) for the limited purpose of responding to my enquiry, sharing product information, facilitating buy/sell requests, and providing related assistance on the <span className="fw-bold">HI Value<sup>+</sup> platform.</span>
                                I understand that my personal data will be <span className="fw-bold">securely stored</span> and used strictly in accordance with Honda India Power Products Ltd.’s <span className="fw-bold">Privacy Notice</span> and applicable data protection laws. My data will be retained only for as long as necessary to fulfil the stated purpose or as required by law.
                                I am aware of my rights as a <span className="fw-bold">data principal</span>, including the right to access, correct, withdraw consent, or request deletion of my personal data at any time. I may withdraw my consent by contacting Honda India Power Products Ltd. through the details provided in the Privacy Policy.
                              </span>
                            </>
                          }
                          <span className="cursor-pointer linkblue fw-semibold" onClick={() => { setShowConsent(!showConsent) }}>{showConsent ? " ..See Less" : " ..See More"}</span>

                          {/* <Link to="/terms-of-use" target="_blank">
                            Terms & Privacy Policy
                          </Link> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mb-2">
                      <ReCAPTCHA
                        style={{ display: "inline-block" }}
                        theme="light"
                        ref={recaptchaRef}
                        sitekey={TEST_SITE_KEY}
                        onChange={onVerifyCaptcha}
                        onExpired={() => {
                          recaptchaRef.current.reset(); // here
                          setCaptchavalue("");
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-12">
                    <div className="relative w-full mb-3">
                      <Button
                        variant="contained"
                        disabled={!enabledbtncapt}
                        className="w-100 hivalueplusSubmitBtn"
                        type="submit"
                      // onClick={() => {
                      //   setShow(true);
                      // }}
                      >
                        Get OTP
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        show={Verificationshow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => setVerificationShow(false)}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => setVerificationShow(false)}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className="px-5 m-5">
            <div className="row">
              {/* <div className="col-12">
                <h4 className=" m-0 fw-bold text-uppercase text-center">
                  <span className="txtdgray">OTP Verification</span>
                </h4>
              </div> */}
              <div className="col-12 txtdgray text-center py-4">
                {otpverificationresponse}
              </div>
              <div className="col-12 d-flex justify-content-center mt-2">
                <div
                  className="hivalueplussectionBtn d-flex justify-content-center align-items-center p-2"
                  style={{ width: "120px" }}
                  onClick={() => {
                    setVerificationShow(false);
                    navigate("/myaccount/sell-your-product");
                  }}
                >
                  OK
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        show={dealershow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => {
          setdealerShow(false);
        }}
        aria-labelledby="video-lg"
      >
        <Modal.Header closeButton className="  mx-4 mt-2  px-0">
          <span className="hivalueplusmodalheader">Dealer’s List</span>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="px-3 mt-2">
            <div className="row">
              <form
                className="col-12"
                // onSubmit={formikOtpVerify.handleSubmit}
                autoComplete="off"
              >
                <div className="overflow-auto" style={{ maxHeight: "400px" }}>
                  <FormGroup>
                    {dealerList.map((dealer) => {
                      const isSelected = selected.includes(dealer);

                      return (
                        <Card
                          key={dealer.dealerid}
                          variant=""
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 1.5,
                            paddingRight: 2,
                            paddingLeft: 2,
                            marginBottom: 1,
                            // p: 0 2 0 2,
                            // mb: 2,
                          }}
                        >
                          {/* Checkbox */}
                          <Checkbox
                            checked={isSelected}
                            onChange={() => handleSelect(dealer)}
                            sx={{
                              color: "grey.400",
                              "&.Mui-checked": { color: "primary.main" },
                              alignSelf: "flex-start",
                            }}
                          />

                          {/* Dealer Info */}
                          <Card
                            variant="outlined"
                            sx={{
                              // border: "gray",
                              borderRadius: 2,
                              borderWidth: 2,
                              p: 1,

                              borderColor: isSelected
                                ? "primary.main"
                                : "grey.300",
                              boxShadow: isSelected ? 3 : 0,
                              transition: "0.2s",
                              flexGrow: 1,
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: "bold",
                                color: "#0873bb",
                                mb: 0.3,
                                textTransform: "uppercase",
                              }}
                            >
                              {dealer.dealerName}
                            </Typography>

                            <Typography sx={{ mb: 0.3, fontSize: "12px" }}>
                              <strong>Address:</strong> {dealer.dealerAddress2}{" "}
                              {dealer.dealerAddress3} {dealer.dealerAddress4} ,
                              {dealer.dealerState} ,{dealer.dealerCity}
                            </Typography>
                            <Typography sx={{ mb: 0.3, fontSize: "12px" }}>
                              <strong>Pin Code:</strong> {dealer.dealerPinCode}
                            </Typography>
                          </Card>
                        </Card>
                      );
                    })}
                  </FormGroup>
                </div>
                {dealererrMessage !== "" ? (
                  <Alert className="text-center" severity="error">
                    {dealererrMessage}
                  </Alert>
                ) : null}
                <div className="col-lg-12 col-12">
                  <div className="relative w-full d-flex justify-content-center mb-3 mt-3">
                    <Button
                      variant="contained"
                      className="hivalueplusSubmitBtn"
                      // type="submit"
                      onClick={() => {
                        if (selected.length > 0) {
                          setShow(true);
                          setdealerShow(false);
                        } else {
                          setDealerErrMessage(
                            "Please Select atleast one dealer"
                          );
                        }
                      }}
                    >
                      Select & Next
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Price calculation Modal */}
      <Modal
        size="lg"
        centered
        show={modalshow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded"
        onHide={() => setModalShow(false)}
        aria-labelledby="video-lg"
      >
        <Modal.Header closeButton className="  mx-4 mt-2  px-0">
          <span className="hivalueplusmodalheader">Price Calculation</span>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="px-4 pt-3 pb-3 ">
            <div className="d-flex justify-content-between flex-column flex-lg-row gap-3">
              <div className="d-flex flex-column flex-lg-row gap-2 align-items-center hidatediv">
                <p className="hivalueplusmodalheading mb-0">Purchased Date</p>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDatePicker
                    views={["year", "month", "day"]}
                    inputFormat="dd-MM-yyyy"
                    value={value}
                    minDate={new Date("2014-01-01")}
                    maxDate={new Date()}
                    onChange={handleChange}
                    sx={{
                      padding: "8.5px 0",
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{
                          width: 160,

                          // CORRECT: Target the stable class name for the inner container
                          "& .MuiPickersOutlinedInput-sectionsContainer": {
                            // Override the large default padding to match a 'small' TextField
                            padding: "8.5px 14px",
                          },

                          // Optional: Keep your other custom styles
                          "& .MuiOutlinedInput-root fieldset": {
                            borderRadius: 6,
                          },
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>

              <div className="d-flex flex-column flex-lg-row gap-2 align-items-center">
                <p className="hivalueplusmodalheading mb-0">Invoice Amount</p>
                <TextField
                  id="input-with-icon-textfield"
                  value={invoiceAmount}
                  onChange={(e) => setInvoiceAmount(e.target.value)}
                  sx={commonTextFieldStyles}
                  // label="TextField"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <CurrencyRupeeIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    },
                  }}
                  variant="outlined"
                />
              </div>
            </div>
          </div>
          <div className="px-4">
            <div className="row">
              <div className="col-12 ">
                <div className="table-responsive">
                  <table className="table hitable">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Content</th>
                        <th>Criteria</th>
                      </tr>
                    </thead>
                    <tbody>
                      {criteriaList.map((section, sectionIndex) =>
                        section.List.map((row, rowIndex) => (
                          <tr
                            key={`${sectionIndex}-${rowIndex}`}
                            className={
                              section.item === "Hunting"
                                ? "hihighlight-row"
                                : ""
                            }
                          >
                            {rowIndex === 0 && (
                              <td
                                rowSpan={section.List.length}
                                className="hiitem-col"
                              >
                                {section.criteriaName}
                              </td>
                            )}
                            <td>{row.criteriaName}</td>
                            <td>
                              <Rating
                                name={`rating-${sectionIndex}-${rowIndex}`}
                                value={row.star}
                                max={3}
                                onChange={(_, newValue) =>
                                  handleRatingChange(
                                    sectionIndex,
                                    rowIndex,
                                    newValue
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="px-4 pb-3 text-end">
            <button
              className="hipricecalculationbtn"
              onClick={(e) => {
                //  setModalShow(false);
                handleSubmitCalculation(e);
              }}
            >
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <HIFotterMain />
    </>
  );
};

export default AddProductHIVALUEPLUS;
// first category then model then sub category will automatically get selected
